module.exports = __webpack_public_path__ + "static/media/instagram.5b18fff8.png";